import React, { useCallback, useEffect, useState } from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { ZoInputText } from '../zo-input-text-temp/zo-input-text-temp';
import Button from '@mui/material/Button';
import { SVGS } from '../assets';
import './contact-details-screen.scss';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { SellerDetails } from '@zonofi/zo-types';
import {
  getUserData,
  getWorkspaceId,
  JTBDEventType,
  useAppSelector,
  useEventTracking,
} from '@zonofi/seller-rtk-store';
import { CustomSvg } from '@zonofi/gandalf-utilities';
import { isEmpty } from 'lodash';

interface ContactDetailsScreenProps {
  goBack: () => void;
  setBusinessCategory: () => void;
  sellerDetails: SellerDetails;
  onUpdateValue: (key: string, value: string) => void;
}

export const ContactDetailsScreen: React.FC<ContactDetailsScreenProps> = ({
  goBack,
  setBusinessCategory,
  sellerDetails,
  onUpdateValue,
}) => {
  const [contactNameError, setContactNameError] = useState('');
  const [emailIdError, setEmailIdError] = useState('');
  const userData = useAppSelector(getUserData);
  const workspaceId = useAppSelector(getWorkspaceId);
  const { trackEvent } = useEventTracking();

  const validate = useCallback(() => {
    let isValid = true;

    // Contact Name: required + alphabetic only
    if (!sellerDetails?.contactName.trim()) {
      setContactNameError('This field is required.');
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(sellerDetails?.contactName)) {
      setContactNameError('Only letters and spaces allowed');
      isValid = false;
    } else {
      setContactNameError('');
    }

    // Email: required + valid format
    if (!sellerDetails?.emailId.trim()) {
      setEmailIdError('This field is required.');
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(sellerDetails?.emailId)) {
      setEmailIdError('Enter a valid email ID');
      isValid = false;
    } else if (sellerDetails?.phoneNumber.length < 10) {
      setEmailIdError('Enter a valid mobile number');
      isValid = false;
    } else {
      setEmailIdError('');
    }

    return isValid;
  }, [sellerDetails]);

  const handleContinue = () => {
    if (validate()) {
      trackEvent(JTBDEventType.SIGNUP_CONTACT_DETAILS_PROVIDED, {
        ...sellerDetails,
      });
      console.log('Continue with contact details');
      setBusinessCategory();
    }
  };
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        if (validate()) {
          console.log('Continue with contact details');
          setBusinessCategory();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [validate]);

  console.log('sellerDetails ====================>', sellerDetails);

  return (
    <SignUpContainer customClass="custom">
      <div className="contact-details-screen">
        <div className="contact-details-screen-header">
          <h2 className="primary-font-semibold seller-font-size-heading">
            Contact Details
          </h2>
          <span className="primary-font-regular seller-font-size-regular sub-heading">
            Please provide your primary contact information for account
            communication.
          </span>
        </div>

        <div className="contact-details-section">
          <div className="input_sec">
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
              }}
            >
              <CustomSvg
                svg={SVGS.UserIconComponent}
                height={20}
                width={20}
                colors={{
                  fill: '#8C8C8C',
                }}
                className="GstinIcon"
              />
              <div
                style={{
                  width: '402px',
                }}
              >
                <ZoInputText
                  title="Contact Name"
                  required={true}
                  placeholder="Enter Contact Name"
                  name="contactName"
                  focusInput={true}
                  value={sellerDetails?.contactName}
                  onBlur={() => {}}
                  inputFieldProps={{
                    value: sellerDetails?.contactName,
                    onChange: (e: { target: { value: string } }) => {
                      const input = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                      const formatted = input
                        .split(' ')
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        )
                        .join(' ');

                      onUpdateValue('contactName', formatted);
                    },
                  }}
                  error={!!contactNameError}
                />
                {contactNameError && (
                  <div className="contactErrorMsg">
                    <span className="icon">
                      <img
                        src={SVGS.ErrorIcon}
                        width={16}
                        height={16}
                        className="ErrorIcon"
                      />
                    </span>
                    {contactNameError}{' '}
                  </div>
                )}
              </div>
            </div>
            <div>
              {sellerDetails?.isEmail ? (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                  }}
                >
                  <CustomSvg
                    svg={SVGS.PhoneIconComponent}
                    height={20}
                    width={20}
                    colors={{
                      fill: '#8C8C8C',
                    }}
                    className="GstinIcon"
                  />
                  <div
                    style={{
                      width: '402px',
                    }}
                  >
                    <ZoInputText
                      title="Phone Number"
                      required={true}
                      placeholder="Enter Phone Number"
                      name="phoneNumber"
                      startAdornment={'+91'}
                      value={sellerDetails?.phoneNumber}
                      onBlur={() => {}}
                      inputFieldProps={{
                        value: sellerDetails?.phoneNumber,
                        onChange: (e: { target: { value: string } }) => {
                          const value = e.target.value.replace(/[^0-9\s]/g, '');
                          if (value.length <= 10) {
                            onUpdateValue('phoneNumber', value);
                          }
                        },
                      }}
                    />
                    {emailIdError && (
                      <div className="contactErrorMsg">
                        <span className="icon">
                          <img
                            src={SVGS.ErrorIcon}
                            width={16}
                            height={16}
                            className="ErrorIcon"
                          />
                        </span>
                        {emailIdError}{' '}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                  }}
                >
                  <CustomSvg
                    svg={SVGS.EmailIconComponent}
                    height={20}
                    width={20}
                    colors={{
                      fill: '#8C8C8C',
                    }}
                    className="GstinIcon"
                  />
                  <div
                    style={{
                      width: '402px',
                    }}
                  >
                    <ZoInputText
                      title="Email Id"
                      required={true}
                      placeholder="Enter Email id"
                      name="email"
                      value={sellerDetails?.emailId}
                      onBlur={() => {}}
                      inputFieldProps={{
                        value: sellerDetails?.emailId,
                        onChange: (e: { target: { value: string } }) =>
                          onUpdateValue('emailId', e.target.value),
                      }}
                      error={!!emailIdError}
                    />
                    {emailIdError && (
                      <div className="contactErrorMsg">
                        <span className="icon">
                          <img
                            src={SVGS.ErrorIcon}
                            width={16}
                            height={16}
                            className="ErrorIcon"
                          />
                        </span>
                        {emailIdError}{' '}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          {sellerDetails.isEmail ? (
            <div className="info-block">
              <span className="PhoneIcon">
                <CustomSvg
                  svg={SVGS.EmailIconComponent}
                  height={20}
                  width={20}
                  colors={{
                    fill: '#8C8C8C',
                  }}
                  className="GstinIcon"
                />
              </span>
              <div className="contactInfo">
                <label>Email</label>
                <p className="primary-font-regular">
                  {sellerDetails?.emailId}{' '}
                  <span className="icon" style={{ marginLeft: '2px' }}>
                    <img
                      src={SVGS.SuccessTick}
                      width={20}
                      height={20}
                      className="SuccessTick"
                    />
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <div className="info-block">
              <span className="PhoneIcon">
                <CustomSvg
                  svg={SVGS.PhoneIconComponent}
                  height={20}
                  width={20}
                  colors={{
                    fill: '#8C8C8C',
                  }}
                  className="GstinIcon"
                />
              </span>
              <div className="contactInfo">
                <label>Mobile Number</label>
                <p className="primary-font-regular">
                  +{sellerDetails?.phoneNumber}{' '}
                  <span className="icon" style={{ marginLeft: '2px' }}>
                    <img
                      src={SVGS.SuccessTick}
                      width={20}
                      height={20}
                      className="SuccessTick"
                    />
                  </span>
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="details_bottomSec">
          <Button className="backbutton" variant="text" onClick={goBack}>
            <span>
              <img
                src={SVGS.ArrowLeft}
                width={20}
                height={20}
                className="ArrowLeft"
              />
            </span>{' '}
            Back
          </Button>
          <ZoButton
            label="Continue"
            endIcon={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={SVGS.ArrowRight}
                  width={20}
                  height={20}
                  className="ArrowRight"
                />
              </span>
            }
            disabled={
              isEmpty(sellerDetails?.contactName) ||
              isEmpty(sellerDetails?.emailId) ||
              isEmpty(sellerDetails?.phoneNumber)
            }
            onClick={handleContinue}
            className="sign-up-now-btn"
          />
        </div>
      </div>
    </SignUpContainer>
  );
};
